import { useState, useEffect } from 'react'
import { Button, IconButton, Box, Stack, MenuItem, FormControl, InputLabel, TextField, Select, Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Dialog, DialogTitle, DialogContent, DialogActions, Pagination, useMediaQuery } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import RefreshIcon from '@mui/icons-material/Refresh'
import { useTheme } from '@mui/material/styles'
import { useConfirm } from '@/components/ConfirmProvider'
import { cmmSend, cmmCd } from 'api/comp';

const headerCellStyle = {
  // width: '80px',
  bgcolor: 'grey.50',
  borderTop: '1px solid',
  borderColor: 'divider',
  cursor: 'pointer',
  color: 'text.primary',
  textAlign: 'center',
  textDecoration: 'none'
}

const AuthDialog = ({ open, onClose, onConfirm }) => {
  const { alert } = useConfirm();
  const theme     = useTheme()
  const isMobile  = useMediaQuery(theme.breakpoints.down('sm')) 

  const [selectedAuth, setSelectedAuth] = useState(null)
  const [page, setPage]                 = useState(1)
  const [totalPage, setTotalPage]       = useState(0)
  const itemsPerPage = 10;
  const [insttCmb, setInsttCmb] = useState([]);   // 기관콤보

  // 조회조건.
  const [paramData, setParamData] = useState({
      page : page,
      authGradeCode : "",
      authGroupName : "",
  });
  const [authInfoList, setAuthInfoList] = useState([]);   // 기관검색 정보
  // const filteredInstt = authInfoList.filter(auth =>
  //   auth.insttNm.includes(paramData.insttNm) || auth.insttNm.includes(paramData.insttNm)
  // )
  // const paginatedInstt = filteredInstt.slice((page - 1) * itemsPerPage, page * itemsPerPage)

  const handleSelect = (auth) => setSelectedAuth(auth)

  const handleAuthConfirm = () => {
    if (!selectedAuth) return;
    onConfirm?.(selectedAuth);
    onClose?.();
  };

  // 최초설정
  const init = () => {
    cmbInstt();
  }

  // 기관
  const cmbInstt = async () => {

    try {
      const resData = await cmmSend('/getAuthInstt', paramData);
      setInsttCmb(resData.data.content);

    } catch (error) {
      console.error('기관정보 불러오기 실패:', error);
    }
  };

  // 검색
  const searchData = async () => {
    //  console.log("검색 !!");
    if (!paramData.authGradeCode) return alert("기관이 선택되지 않았습니다.");

    try {
      // console.log("검색2 !!"+ paramData.page);
      const resData = await cmmSend('/getAuthInfoList', paramData);
      setAuthInfoList(resData.data.content);
      setTotalPage(resData.data.totalPages);

    } catch (error) {
      console.error('기관정보 불러오기 실패:', error);
    }
  };

  /* 최초 화면설정 */
  useEffect(() => {
    init();
  }, [])

  /* Dialog 팝업시 조회 조건 초기화 */
  useEffect(() => {
    if ( open ) {
      // console.log("화면 시작 !!");
      // 조회조건 값 초기화
      setParamData({
        page : page,
        authGradeCode : "",
        authGroupName : "",
      });
      setAuthInfoList([]);
      setTotalPage(0);
    }
  }, [ open ]);

  /* 콤보 선택시 하위 분류 조회 */
  useEffect(() => {
    if( open ) {
      searchData();
    }
  }, [ page ]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      fullScreen={isMobile}
      PaperProps={{
        sx: isMobile
          ? {
              position: 'fixed',
              bottom: 0,
              m: 0,
              borderTopLeftRadius: theme.spacing(2),
              borderTopRightRadius: theme.spacing(2),
              display: 'flex',
              flexDirection: 'column',
              maxHeight: '90dvh',
              minHeight: 0,
              overflow: 'hidden'
            }
          : {}
      }}
    >
      <DialogTitle
        component="div"
        variant={isMobile ? 'h5' : 'h3'}
        sx={{ mb: isMobile ? 0 : 2, pr: 4 }}
      >
        권한검색
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: '16px',
            top: '16px',
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={1} flexWrap="wrap" sx={{ pt: 1 }}>
          {/* 기관 */}
          <FormControl sx={{ flex: 4 }} margin="normal">
            <InputLabel id="major-select-label" shrink>기관</InputLabel>
            <Select
              labelId="major-select-label"
              id="major-select"
              value={paramData.authGradeCode}
              label="기관 "
              onChange={(e) =>{
                setParamData({
                    ...paramData,
                  authGradeCode : e.target.value
                })
              }
              }
            >
              <MenuItem value="">선택</MenuItem>
              {
                insttCmb?.map((item) =>
                  <MenuItem value={item.authGradeCode}>{item.authGradeName}</MenuItem>
                )
              }
            </Select>
          </FormControl>

        </Stack>

        <Stack direction={{ xs: 'column', md: 'row' }} spacing={1} flexWrap="wrap" sx={{ pt: 1 }}>
          {/* 기관명 */}
          <TextField
            sx={{ flex: 10 }}
            margin="normal"
            label="권한명"
            value={paramData.authGroupName}
            onChange={(e) => {
              setParamData({
                  ...paramData,
                  authGroupName : e.target.value
              })
              setPage(1)
            }}
            onKeyDown={(e) => {
              // 엔터 시 실행할 기능 추가
              if (e.key === "Enter") {
                searchData();
              }
            }}
          /> 

          <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
            <IconButton
              sx={{ p: 0.8, border: '1px solid #ccc', borderRadius: '8px' }}
              aria-label="검색"
              onClick={(e) =>
                setParamData({
                  ...paramData,
                  authGradeCode : "",
                  authGroupName : "",
                })
              }>
              <RefreshIcon/>
            </IconButton>
            <Button variant="contained" color="primary" sx={{ flex: 1, borderRadius: 0.6 }} onClick={searchData}>검색</Button>
          </Box>
        </Stack>

        <TableContainer sx={{ mt: 3 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={headerCellStyle}>번호</TableCell>
                <TableCell sx={headerCellStyle}>기관명</TableCell>
                <TableCell sx={headerCellStyle}>권한명</TableCell>
                <TableCell sx={headerCellStyle}>등록자</TableCell>
                <TableCell sx={headerCellStyle}>선택</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
              authInfoList.length === 0 ? (
                <TableRow>
                  <TableCell align="center" colSpan={5}>검색된 데이터가 없습니다.</TableCell>
                </TableRow>
              ) : (
              authInfoList.map((auth) => (
                <TableRow
                  key={auth.authGroupId}
                  hover
                  selected={selectedAuth?.authGroupId === auth.authGroupId}
                  sx={selectedAuth?.authGroupId === auth.authGroupId ? { bgcolor: 'action.selected' } : {}}
                >
                  <TableCell align="center">{auth.rowNum}</TableCell>
                  <TableCell align="center">{auth.authGradeName}</TableCell>
                  <TableCell align="center">{auth.authGroupName}</TableCell>
                  <TableCell align="left">{auth.registId}</TableCell>
                  <TableCell align="center">
                    <Button
                      variant={selectedAuth?.authGroupId === auth.authGroupId ? 'contained' : 'outlined'}
                      color={selectedAuth?.authGroupId === auth.authGroupId ? 'primary' : 'warning'}
                      onClick={() => handleSelect(auth)}
                    >
                      선택
                    </Button>
                  </TableCell>
                </TableRow>
              ))
              )

              }
            </TableBody>
          </Table>
        </TableContainer>

        {
          totalPage !== 0 && (
            <Pagination
              count={Math.ceil((totalPage? totalPage : 0) / itemsPerPage)}
              page={page}
              onChange={(e, value) =>{
                setParamData({
                  ...paramData,
                  page : value 
                });
                setPage(value)
              }}
              showFirstButton
              showLastButton
              sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}
            />
          )
        }
      </DialogContent>
      <DialogActions
        sx={{
          px: { xs: 2, sm: 3 },
          position: { xs: 'sticky', sm: 'static' },
          bottom: 0,
          bgcolor: 'background.paper',
          borderTop: '1px solid',
          borderColor: 'divider',
          pb: { xs: `calc(${theme.spacing(2)} + env(safe-area-inset-bottom))`, sm: 2 },
          pt: 2,
          gap: 0.5,
          '& .MuiButton-root': { 
            width: { xs: '100%', sm: 'auto' },
            px: 3,
            py: 1,
          }
        }}
      >
        <Button size="large" variant="outlined" color="grey" onClick={onClose}>취소</Button>
        <Button size="large" variant="contained" onClick={handleAuthConfirm}>확인</Button>
      </DialogActions>
    </Dialog>
  )
}

export default AuthDialog
